import React from "react";
import PropTypes from "prop-types";
import { MdContentCopy } from "react-icons/md";
import { IconButton, PopoverPaper } from "../../atomicComponents";
import styles from "./VcPendingMasterDataInfo.module.css";
import { usePlantAndLinesStore } from "../../providers/PlantAndLinesStore/PlantAndLinesStore";
import { JLR_PLANT } from "../../constants";

const VcPendingMasterDataInfo = ({
  isBasicInfoPending,
  isCostReleasePending,
  isSMHPending,
  isVCAggregateBomPending,
  isVcMasterDataConfirmed,
  open,
  handleClose,
  anchorEl,
  vc,
}) => {
  const [plant] = usePlantAndLinesStore().plantState;
  const isLucknowProlifePlant = plant?.label == 'Lucknow-Prolife'
  const parentName = isLucknowProlifePlant ? 'Part' : 'VC'

  return (
    <PopoverPaper
      open={open}
      handleClose={handleClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.vcText}>{parentName}</div>
          <div className={styles.vcFlex}>
            <span className={styles.vcNo}>{vc}</span>
            <IconButton
              description="copy"
              className={styles.copyButton}
              onClick={() => navigator.clipboard.writeText(vc)}
            >
              <MdContentCopy className={styles.copyIcon} />
            </IconButton>
          </div>
        </div>
        <div className={styles.infoArea}>
          Pending
          <div className={JLR_PLANT !== plant.label ? styles.info : styles.infoJLR}>
            <div>{isBasicInfoPending && "Basic Info"}</div>
            <div>{isVcMasterDataConfirmed&&"Configuration pending at GMES"}</div>
            <div>{isCostReleasePending && "Cost Release"}</div>
            <div>{isSMHPending && "SMH"}</div>
            {JLR_PLANT !== plant.label ? (
              <div>{isVCAggregateBomPending && "Aggregate BOM"}</div>
            ) : null}
          </div>
        </div>
      </div>
    </PopoverPaper>
  );
};

VcPendingMasterDataInfo.propTypes = {
  anchorEl: PropTypes.instanceOf(Element),
  vc: PropTypes.string.isRequired,
  isBasicInfoPending: PropTypes.bool,
  isCostReleasePending: PropTypes.bool,
  isSMHPending: PropTypes.bool,
  isVCAggregateBomPending: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default VcPendingMasterDataInfo;
